import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { ProgressChart } from '~/modules/common/charts/dashboard';
import { getProgressHourChartData } from '~/modules/projects/project/common/util';

export const ProgressHourChart = ({ summary, isLoading = false, error }) => {
  const intl = useIntl();

  const {
    budget,
    actual,
    estimatedAtCompletion,
    estimatedBudgetRemaining,
    budgetRemaining,
    estimatedRemaining,
    percentBudgetBurned,
    percentScopeCompleted
  } = getProgressHourChartData({
    progressChartProps: summary
  });

  return (
    <>
      <ProgressChart
        budget={budget}
        actual={actual}
        estimatedAtCompletion={estimatedAtCompletion}
        estimatedBudgetRemaining={estimatedBudgetRemaining}
        budgetRemaining={budgetRemaining}
        estimatedRemaining={estimatedRemaining}
        percentBudgetBurned={percentBudgetBurned}
        percentScopeCompleted={percentScopeCompleted}
        burnedAlertMessage="dashboardProgressChart.budgetBurnedAlert"
        burnedId="dashboardProgressChart.budgetBurned"
        scopeCompletedAlertMessage="dashboardProgressChart.scopeCompletedAlert"
        scopeCompletedId="dashboardProgressChart.scopeCompleted"
        fixedDecimalScale={false}
        suffix={intl.formatMessage({
          id: 'dashboardProgressChart.hrs'
        })}
        dataQeId="ProgressHourChart"
        isLoading={isLoading}
        error={error}
      />
    </>
  );
};

ProgressHourChart.propTypes = {
  summary: PropTypes.object,
  isLoading: PropTypes.bool,
  error: PropTypes.object
};

export default ProgressHourChart;
